<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<style>
/* Estilo global para transição de página */
.page-enter-active,
.page-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
.page-enter-to,
.page-leave-from {
  opacity: 1;
  transform: translateY(0);
}

/* CSS global para garantir altura total e footer correto */
html,
body,
#__nuxt,
.v-application {
  min-height: 100%;
  margin: 0;
}

.v-application {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.v-main {
  flex-grow: 1;
}
</style>
